import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export const PrivateOnly = createSlice({
  name: 'PrivateOnly',
  initialState: {
    privateOnly: false
  },
  reducers: {
    setPrivateOnly: (state, val: PayloadAction<boolean>) => {
      state.privateOnly = val.payload;
    }
  },
});

export const { setPrivateOnly } = PrivateOnly.actions;
export default PrivateOnly.reducer;